import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Refreshes the Calypso boutique stock line when another variant is selected,
 * using the section HTML the variant picker already fetched.
 */
class CalypsoStock extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {Event & { promise: Promise<{ detail?: any }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const updated = detail.html.querySelector('calypso-stock');
        if (!updated) return;

        morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[calypso-stock] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('calypso-stock')) {
  customElements.define('calypso-stock', CalypsoStock);
}
